import axios from "./axios";
const base = "/biz/amazon/competition";
const post = (path, body = {}) => axios.post(base + path, body, {
  headers: { "Content-Type": "application/json;charset=UTF-8" },
});
export default {
  page: params => axios.get(base + "/page", { params }),
  validateProduct: commodityAsin => axios.get(base + "/validate-product", { params: { commodityAsin } }),
  save: body => post("/save", body),
  remove: id => post(`/delete/${id}`),
  operations: params => axios.get(base + "/operations", { params }),
};
